import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  private promotionLevelSubject = new BehaviorSubject<number>(null);
  promotionLevel$ = this.promotionLevelSubject.asObservable();

  setPromotionLevel(value: number): void {
    this.promotionLevelSubject.next(value);
  }

  getPromotionLevel(): number {
    return this.promotionLevelSubject.value;
  }
}